import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Component to redirect URLs with query parameters to clean URLs
 * This handles the deprecation of old URLs with redundant query parameters
 */
const CleanUrlRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if URL has query parameters that should be removed
    const searchParams = new URLSearchParams(location.search);
    
    // If there are query parameters, redirect to clean URL
    if (searchParams.toString()) {
      const cleanUrl = location.pathname;
      navigate(cleanUrl, { replace: true });
    }
  }, [location, navigate]);

  return null; // This component doesn't render anything
};

export default CleanUrlRedirect;
